import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';

export interface CreateProductProps extends Omit<ProductProps, 'id'> {}

const useCreateProduct = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: ProductProps) => {
    create(productsKeys.list(), data);
  };

  return useApiMutation<ProductProps>({
    url: '/products',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar produto',
    successTitle: 'Cadastrar produto',
    successMessage: 'Produto cadastrado com sucesso',
    redirectUrl: (data) => `/menu/products/${data.id}`,
    onSuccess,
  });
};

export default useCreateProduct;
